module.exports = __webpack_public_path__ + "img/1_4_1.19567a47.jpg";